import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { TextBoldStyle, TextRegStyle } from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';

export interface ContestDescriptionProps {
  content: ReactNode;
}

export const ContestDescription: FC<ContestDescriptionProps> = ({ content }) => {
  return (
    <SCContestDescription>
      {content}
    </SCContestDescription>
  );
};

const SCContestDescription = styled.div`
  background-color: var(--white-color);
  padding: 32px 24px;
  
  * {
    ${TextRegStyle};
    color: var(--black-color);
  }

  a {
    ${TextRegStyle};
    color: var(--primary-color);
  }

   p {
    margin-bottom: 0;
    text-indent: 24px;
  }
  
   b, h3 {
     ${TextBoldStyle};
     color: var(--black-color);
     font-weight: 700;
   }
  
  i {
    ${TextRegStyle};
    font-style: italic;
  }
  
  h3 {
   text-align: center;
   margin-top: 20px;
  }
  
  > *:not(:last-child) {
    margin-bottom: 8px;
  }
  
  ${lessThan('sm')} {
    padding: 20px 16px;

    p {
      margin-bottom: 0;
      text-indent: 20px;
    }
  }
`;
